import {
  put,
  putResolve,
  takeLatest,
  takeEvery,
  select,
  all,
  call,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import _ from 'lodash';
import history from 'app/routes/history';
import {
  teamPaymentRequestSchema,
  teamPaymentRequestListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { getAllPaymentEvents } from 'app/ducks/paymentEvents/actions';
import {
  createTeamPaymentCollection,
  getAllTeamPaymentCollections,
} from 'app/ducks/teamPaymentCollections/actions';
import { getAllTeamMembers } from 'app/ducks/teamMembers/actions';

import {
  sagaActions,
  getTeamPaymentRequest,
} from 'app/ducks/teamPaymentRequests/actions';
import { TeamPaymentRequestsActionTypes as types } from 'app/ducks/teamPaymentRequests/types';

function* createTeamPaymentRequestSaga(action): any {
  let teamMemberIds = [];
  const { payload } = action;
  teamMemberIds = action.payload.teamMemberIds;

  delete payload.teamMemberIds;
  yield put(sagaActions.createTeamPaymentRequestPending(payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).teamPaymentRequests.create(payload);
  if (response) {
    // if (!_.isEmpty(teamMemberIds)) {
    //   let consumerId;
    //   yield all(
    //     teamMemberIds.map((teamMemberId) => call(function* () {
    //       consumerId = yield select(
    //         (state) => state.teamMembers.teamMembersById[teamMemberId].consumer.id,
    //       );
    //       const teamMemberData = {
    //         teamPaymentRequest: {
    //           id: response.data.id,
    //         },
    //         teamMember: {
    //           id: teamMemberId,
    //         },
    //         consumer: {
    //           id: consumerId,
    //         },
    //       };
    //       const actionSend = yield createTeamPaymentCollection(teamMemberData);
    //       yield put(actionSend);
    //       return teamMemberData;
    //     })),
    //   );
    // }
    const normalizedResponse = normalize(response, teamPaymentRequestSchema);
    // yield put(yield getTeamPaymentRequest(response.data.id));
    // yield put(yield getAllTeamPaymentCollections(response.data.id));
    yield put(sagaActions.createTeamPaymentRequestSuccess(normalizedResponse));
    history.push(`/payment-requests/detail/${response.data.id}`);
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createTeamPaymentRequestFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updateTeamPaymentRequestSaga(action): any {
  yield put(sagaActions.updateTeamPaymentRequestPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).teamPaymentRequests.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, teamPaymentRequestSchema);

    yield put(sagaActions.updateTeamPaymentRequestSuccess(normalizedResponse));
    // const searchPayload = {
    //   filter: {
    //     paymentRequestId: action.payload.id,
    //   },
    //   context: 'updateTeamPaymentRequestSaga',
    // };
    // // console.log('search');
    // // console.log(searchPayload);
    // // yield put(yield getAllTeamPaymentCollections(searchPayload, false));
    history.push(`/payment-requests/detail/${response.data.id}`);
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateTeamPaymentRequestFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getTeamPaymentRequestSaga(action): any {
  yield put(sagaActions.getTeamPaymentRequestPending());
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).teamPaymentRequests.show(action.payload);
  // console.log(response);

  if (response) {
    const normalizedResponse = normalize(response, teamPaymentRequestSchema);
    yield all([
      put(sagaActions.getTeamPaymentRequestSuccess(normalizedResponse)),
      put(yield getAllTeamMembers()),
    ]);
    // put(yield getAllTeamPaymentCollections(action.payload)),
    const result = normalizedResponse.entities.teamPaymentRequests[
      normalizedResponse.result
    ];

    if (!_.isEmpty(result.matchPayment?.id)) {
      const matchFilter = {
        filter: {
          'match-payment-id': result.matchPayment?.id,
          'group-id': result.group?.id,
        },
      };
      yield putResolve(
        yield getAllPaymentEvents(matchFilter, false, undefined, true),
      );
    }

    return result;
  }
  yield put(
    handleError(
      error,
      sagaActions.getTeamPaymentRequestFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllTeamPaymentRequestsSaga(action): any {
  yield put(
    sagaActions.getAllTeamPaymentRequestsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.teamPaymentRequests.pagination),
    )
    : action.payload.pagination;

  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).teamPaymentRequests.list(paginationObject);
  if (response) {
    const normalizedResponse = normalize(
      response,
      teamPaymentRequestListSchema,
    );
    yield put(
      sagaActions.getAllTeamPaymentRequestsSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllTeamPaymentRequestsFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createTeamPaymentRequestSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_TEAM_PAYMENT_REQUEST_REQUESTED,
    createTeamPaymentRequestSaga,
  );
}

function* updateTeamPaymentRequestSagaWatcher(): any {
  yield takeLatest(
    types.UPDATE_TEAM_PAYMENT_REQUEST_REQUESTED,
    updateTeamPaymentRequestSaga,
  );
}

function* getTeamPaymentRequestSagaWatcher(): any {
  yield takeLatest(
    types.GET_TEAM_PAYMENT_REQUEST_REQUESTED,
    getTeamPaymentRequestSaga,
  );
}

function* getAllTeamPaymentRequestsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_TEAM_PAYMENT_REQUESTS_REQUESTED,
    getAllTeamPaymentRequestsSaga,
  );
}

export default function* root(): any {
  yield all([
    createTeamPaymentRequestSagaWatcher(),
    updateTeamPaymentRequestSagaWatcher(),
    getTeamPaymentRequestSagaWatcher(),
    getAllTeamPaymentRequestsSagaWatcher(),
  ]);
}
